// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreStreaming = (client) => ({
    /**
     * `POST /store/streaming/download`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StorePostStreamingDownload
     * @source packages/medusa-plugin-streaming-media/src/api/store/streaming/download/route.ts
     */
    download: (body, query, headers) => client.fetch("/store/streaming/download", { method: "POST", body, query, headers }),
    /**
     * `POST /store/streaming/preview`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StorePostStreamingPreview
     * @source packages/medusa-plugin-streaming-media/src/api/store/streaming/preview/route.ts
     */
    preview: (body, query, headers) => client.fetch("/store/streaming/preview", { method: "POST", body, query, headers }),
    /**
     * `POST /store/streaming/session`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StorePostStreamingSession
     * @source packages/medusa-plugin-streaming-media/src/api/store/streaming/session/route.ts
     */
    updateSession: (body, query, headers) => client.fetch("/store/streaming/session", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=streaming.js.map